/* eslint-disable no-console */
import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/contentLibrary';
import * as modalTypes from '../constants/actionTypes/modals';
import eventService from '../common/eventService';
import { request } from '../common/request';
import configs from '../constants/configs';
import rules from '../constants/businessRules/businessRules';
import { ERR_CONTENT_LIBRARY, ERR_DELETE_CONTENT } from '../constants/Errors';

export const setFolderContents = createAction(types.SET_FOLDER_CONTENTS);
export const updateFolders = createAction(types.UPDATE_FOLDERS);
export const updateFolderName = createAction(types.UPDATE_FOLDER_NAME);
export const updateFolderContent = createAction(types.UPDATE_FOLDER_CONTENT);
export const deleteFolderContent = createAction(types.DELETE_FOLDER_CONTENT);
export const setLoading = createAction(types.SET_LOADING);
export const updateContentName = createAction(types.UPDATE_CONTENT_NAME);

export const setActiveFolder = (folderID) => (dispatch) => {
    dispatch({
        type: types.SET_LOADING,
        payload: true,
    });

    request
        .get(`${configs.contentLibraryEndpoint}?folderID=${folderID}&quantity=${rules.IMAGE_LIBRARY_LOAD_BATCH_SIZE}`)
        .then((contents) => {
            dispatch({
                type: types.SET_ACTIVE_FOLDER,
                payload: {
                    folderID,
                    contents,
                },
            });
        })
        .catch((error) => {
            console.error(error);
            eventService.notify(error.customMessage ? error.customMessage : ERR_CONTENT_LIBRARY, true);
        })
        .finally(() => {
            dispatch({
                type: types.SET_LOADING,
                payload: false,
            });
        });
};

export const updateContent =
    (quantity, offset, method = types.UPDATE_CONTENT_INSERTION_METHOD.APPEND) =>
    (dispatch, getState) => {
        dispatch({
            type: types.SET_LOADING,
            payload: true,
        });

        const { selectedFolder } = getState().contentLibrary;
        const { id } = selectedFolder;
        request
            .get(`${configs.contentLibraryEndpoint}?folderID=${id}&quantity=${quantity}&offset=${offset}`)
            .then((content) => {
                dispatch({
                    type: types.UPDATE_FOLDER_CONTENT,
                    payload: { content, method },
                });
            })
            .catch((error) => {
                console.error(error);
                eventService.notify(error.customMessage ? error.customMessage : ERR_CONTENT_LIBRARY, true);
            })
            .finally(() => {
                dispatch({
                    type: types.SET_LOADING,
                    payload: false,
                });
            });
    };

export const setContentLibraryTab = (tab) => (dispatch) => {
    dispatch({
        type: modalTypes.SET_MODAL,
        payload: {
            name: 'contentLibraryModal',
            status: true,
            // 1 is Upload to my draft tab
            // 2 is Shared library tab in the modal
            location: tab === 'library' ? 2 : 1,
        },
    });
};

export const setFolders = (tab) => (dispatch, getState) => {
    setContentLibraryTab(tab)(dispatch);

    dispatch({
        type: types.SET_LOADING,
        payload: true,
    });

    request
        .get(configs.contentLibraryFolder)
        .then((folders) => {
            dispatch({
                type: types.SET_FOLDERS,
                payload: folders,
            });

            const { selectedFolder } = getState().contentLibrary;
            const { id } = selectedFolder;
            request
                .get(`${configs.contentLibraryEndpoint}?folderID=${id}&quantity=${rules.IMAGE_LIBRARY_LOAD_BATCH_SIZE}`)
                .then((contents) => {
                    dispatch({
                        type: types.SET_ACTIVE_FOLDER,
                        payload: {
                            folderID: id,
                            contents,
                        },
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: modalTypes.SET_MODAL,
                        payload: {
                            name: 'contentLibraryModal',
                            status: false,
                            location: null,
                        },
                    });
                    eventService.notify(error.customMessage ? error.customMessage : ERR_CONTENT_LIBRARY, true);
                });
        })
        .catch((error) => {
            dispatch({
                type: modalTypes.SET_MODAL,
                payload: {
                    name: 'contentLibraryModal',
                    status: false,
                    location: null,
                },
            });
            console.error(error);
            eventService.notify(error.customMessage ? error.customMessage : ERR_CONTENT_LIBRARY, true);
        })
        .finally(() => {
            dispatch({
                type: types.SET_LOADING,
                payload: false,
            });
        });
};

export const deleteFolder = (folderID) => (dispatch, getState) => {
    const { selectedFolder } = getState().contentLibrary;
    const { id } = selectedFolder;
    request
        .custom(`${configs.contentLibraryFolder}?folderID=${folderID}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(() => {
            dispatch({ type: types.DELETE_FOLDER, payload: folderID });
            if (folderID === id) {
                const allFolders = getState().contentLibrary.folders;
                const newFolderToSelect = allFolders[0].folderID;
                request
                    .get(
                        `${configs.contentLibraryEndpoint}?folderID=${newFolderToSelect}&quantity=${rules.IMAGE_LIBRARY_LOAD_BATCH_SIZE}`
                    )
                    .then((contents) => {
                        dispatch({
                            type: types.SET_ACTIVE_FOLDER,
                            payload: {
                                folderID: newFolderToSelect,
                                contents,
                            },
                        });
                    })
                    .catch((error) => {
                        console.error(error);
                        eventService.notify(error.customMessage ? error.customMessage : ERR_CONTENT_LIBRARY, true);
                    });
            }
        })
        .catch((error) => {
            console.error(error);
            eventService.notify(error.customMessage ? error.customMessage : ERR_DELETE_CONTENT, true);
        });
};
